// extracted by mini-css-extract-plugin
export default {"root":"bLeOje","label":"D8tuQ7","input":"mHImnY"};